import { throwOnError } from './utils';

export type OrganizationApplicationTemplate = {
  id: string;
  issuer_organization_code: string;
  title: string;
  status: 'draft' | 'active' | 'archived';
  application_term_url: string | null;
  // 申込完了後にリダイレクトする先のURL（任意）。未設定(null)ならリダイレクトしない。
  redirect_url: string | null;
  private_money_ids: string[];
  capital_field_option: 'required' | 'optional' | 'hidden';
  number_of_employees_field_option: 'required' | 'optional' | 'hidden';
  referral_source_field_option: 'required' | 'optional' | 'hidden';
  description: string;
  user_tag_group_options?: {
    user_tag_group_id: string;
    field_option: 'required' | 'optional' | 'hidden';
  }[];
  created_at: string;
  updated_at: string;
};

type Paginated<T> = {
  rows: T[];
  count: number;
  pagination: {
    current: number;
    has_next: boolean;
    has_prev: boolean;
    max_page: number;
    per_page: number;
  };
};

type GetOrganizationApplicationTemplatesResponse = Paginated<OrganizationApplicationTemplate>;

export const getOrganizationApplicationTemplates = (query = '') =>
  fetch(`/api/organization-application-templates?${query}`, {
    method: 'GET',
    credentials: 'same-origin',
  }).then(throwOnError<GetOrganizationApplicationTemplatesResponse>);

export const getOrganizationApplicationTemplate = (id: string) =>
  fetch(`/api/organization-application-templates/${id}`, {
    method: 'GET',
    credentials: 'same-origin',
  }).then(throwOnError<OrganizationApplicationTemplate>);

export type CreateOrganizationApplicationTemplateParams = {
  title?: string;
  status?: 'draft' | 'active' | 'archived';
  application_term_url?: string | null;
  redirect_url?: string | null;
  private_money_ids: string[];
  capital_field_option?: 'required' | 'optional' | 'hidden';
  number_of_employees_field_option?: 'required' | 'optional' | 'hidden';
  referral_source_field_option?: 'required' | 'optional' | 'hidden';
  description?: string;
  issuer_organization_code?: string;
};

export const createOrganizationApplicationTemplate = (
  params: CreateOrganizationApplicationTemplateParams
) =>
  fetch('/api/organization-application-templates', {
    method: 'POST',
    credentials: 'same-origin',
    headers: {
      'content-type': 'application/json',
    },
    body: JSON.stringify({ _csrf_token: window._csrf_token, ...params }),
  }).then(throwOnError<OrganizationApplicationTemplate>);

export type UpdateOrganizationApplicationTemplateParams = {
  title?: string;
  status?: 'draft' | 'active' | 'archived';
  application_term_url?: string | null;
  redirect_url?: string | null;
  private_money_ids?: string[];
  capital_field_option?: 'required' | 'optional' | 'hidden';
  number_of_employees_field_option?: 'required' | 'optional' | 'hidden';
  referral_source_field_option?: 'required' | 'optional' | 'hidden';
  description?: string;
};

export const updateOrganizationApplicationTemplate = (
  id: string,
  params: UpdateOrganizationApplicationTemplateParams
) =>
  fetch(`/api/organization-application-templates/${id}`, {
    method: 'PATCH',
    credentials: 'same-origin',
    headers: {
      'content-type': 'application/json',
    },
    body: JSON.stringify({ _csrf_token: window._csrf_token, ...params }),
  }).then(throwOnError<OrganizationApplicationTemplate>);

export type OrganizationApplicationTermFile = {
  id: number;
  url: string;
};

export const uploadOrganizationApplicationTermFile = (templateId: string, file: File) => {
  const formData = new FormData();
  formData.append('file', file);
  formData.append('_csrf_token', window._csrf_token);

  return fetch(`/api/organization-application-templates/${templateId}/term-file`, {
    method: 'POST',
    credentials: 'same-origin',
    body: formData,
  }).then(throwOnError<OrganizationApplicationTermFile>);
};
